import React from "react";
import { Col, Row, Container as GridContainer } from "react-native-flex-grid";
import { Box, FormattedDate, H4, HStack, Paragraph, Text } from "../ui";
import { CartApproval } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { useToken } from "@gluestack-style/react";

type Props = {
	approvalHistory: CartApproval[];
};

const CartApprovalHistory = ({ approvalHistory }: Props) => {
	const isMobile = useIsMobile();
	const resolvedPrimarylight = useToken("colors", "primarylight");

	const actionTypeMapping: { [key: string]: string } = {
		SentForApproval: "Sent for approval",
		Approved: "Approved",
		Rejected: "Rejected",
	};

	const getActionColor = (actionType: string | null) => {
		if (!actionType) return "$neutral700";

		switch (actionType) {
			case "Approved":
				return "$success500";
			case "Rejected":
				return "$error500";
			default:
				return "$neutral700";
		}
	};

	return (
		<GridContainer
			noPadding
			style={{
				maxWidth: "100%",
				marginBottom: 0,
				marginLeft: 0,
				marginRight: 0,
				paddingLeft: 0,
				borderRadius: 8,
				backgroundColor: "$midtealxdark",
				boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.2)",
			}}
		>
			<Box flexDirection="row" paddingHorizontal={isMobile ? 16 : 24} paddingVertical={16} bg="$midtealxdark" borderTopLeftRadius={8} borderTopRightRadius={8} borderBottomStartRadius={0} borderBottomEndRadius={0}>
				<H4 sx={{ color: "white", fontWeight: "600" }}>Order Approval History</H4>
			</Box>
			<Box marginBottom={24} bg="$neutral25" paddingVertical={12} paddingHorizontal={24}>
				{approvalHistory.map((approval, index) => {
					const actionColor = getActionColor(approval.actionType);

					if (isMobile) {
						return (
							<Box key={index} bg="$basicwhite">
								<HStack justifyContent="space-between" mb={8}>
									<Text sx={{ color: actionColor, fontWeight: "600" }}>{approval.actionType ? actionTypeMapping[approval.actionType] : ""}</Text>
									<FormattedDate sx={{ color: "$neutral400", fontSize: 13 }} variant="DD/MM/YYYY hh:mm tt" date={approval.dateCreated} />
								</HStack>

								<Text sx={{ color: "$neutral700", mb: 8 }}>{`${approval.user?.firstName || ""} ${approval.user?.lastName || ""}`.trim()}</Text>

								{approval.actionNote && <Paragraph sx={{ color: "$neutral600", fontSize: 14 }}>{approval.actionNote}</Paragraph>}
							</Box>
						);
					}

					return (
						<Box key={index} bg={index % 2 === 0 ? "$neutral25" : "$basicwhite"}>
							<Row>
								<Col style={{ justifyContent: "center" }}>
									<Text sx={{ color: actionColor, fontWeight: "600" }}>{approval.actionType ? actionTypeMapping[approval.actionType] : ""}</Text>
								</Col>

								<Col style={{ justifyContent: "center" }}>
									<Text sx={{ color: "$neutral700" }}>{`${approval.user?.firstName || ""} ${approval.user?.lastName || ""}`.trim()}</Text>
								</Col>

								<Col style={{ justifyContent: "center" }}>
									<FormattedDate sx={{ color: "$neutral400" }} variant="DD/MM/YYYY hh:mm tt" date={approval.dateCreated} />
								</Col>

								<Col style={{ justifyContent: "center" }}>{approval.actionNote && <Paragraph sx={{ color: "$neutral600", fontSize: 14 }}>{approval.actionNote}</Paragraph>}</Col>
							</Row>
						</Box>
					);
				})}
			</Box>
		</GridContainer>
	);
};

export default CartApprovalHistory;
